var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMetricsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    stroke: "#929292",
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1681_24100)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 8.5V32.5H56",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 32.5C8 35.6517 8.62078 38.7726 9.82689 41.6844C11.033 44.5962 12.8008 47.242 15.0294 49.4706C17.258 51.6992 19.9038 53.467 22.8156 54.6731C25.7274 55.8792 28.8483 56.5 32 56.5C35.1517 56.5 38.2726 55.8792 41.1844 54.6731C44.0962 53.467 46.742 51.6992 48.9706 49.4706C51.1992 47.242 52.967 44.5962 54.1731 41.6844C55.3792 38.7726 56 35.6517 56 32.5C56 29.3483 55.3792 26.2274 54.1731 23.3156C52.967 20.4038 51.1992 17.758 48.9706 15.5294C46.742 13.3008 44.0962 11.533 41.1844 10.3269C38.2726 9.12078 35.1517 8.5 32 8.5C28.8483 8.5 25.7274 9.12078 22.8156 10.3269C19.9038 11.533 17.258 13.3008 15.0294 15.5294C12.8008 17.758 11.033 20.4038 9.82689 23.3156C8.62078 26.2274 8 29.3483 8 32.5Z",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1681_24100"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricsEmpty);
export default __webpack_public_path__ + "static/media/metrics-empty.f30cc4d7cf23d75bb056d9a054bf0aca.svg";
export { ForwardRef as ReactComponent };